'use strict';

module.exports = ['$http',
    function ($http) {

        return {
            restrict: 'E',
            scope: {
                form: '=',
                name: '=',
                title: '=',
                input: '=',
                model: '=',
                details: '=',
                pbreadonly: '=',
                options: '='
            },
            templateUrl: '/partial/app.directives.twitter_users',
            link: function ($scope, element, attributes ) {

                let modelReady = false;
                $scope.twitterUsers = [];

                function error(error, value = null) {
                    if ($scope.form && $scope.form[$scope.name]) { //make shure there is an form
                        if (value == null) {
                            return $scope.form[$scope.name].$error[error];
                        } else {
                            $scope.form[$scope.name].$setValidity(error, value);
                        }
                    }
                }

                //Check whether user exists
                let checkUsername = ( username ) => {

                    $http.get('/social/twitter/userdata/' + username).then((response) => {

                        if (response.data.status == 404) {
                            error('noUsername', false);
                        } else if (response.data.status == 400 && response.data.message == 'no_accounts') {
                            error('noAccounts', false);
                        } else if (response.data.status == 200) {
                            $scope.twitterUsers.push(response.data.userData);

                            if (error('noUsername')) {
                                error('noUsername', true);
                            }
                            if(error('noAccounts')) {
                                error('noAccounts', true);
                            }
                        }
                    });
                }

                //Add user to list
                $scope.add = ( username ) => {
                    checkUsername( username );
                }

                //Remove from user list
                $scope.remove = ( index ) => {

                    $scope.twitterUsers.splice(index, 1);
                }

                //Watch model changes
                $scope.$watch('model', (newVal) => {
                    if(newVal !== undefined && !modelReady) {

                        //console.log($scope.model)

                        $scope.model = $scope.model || [];

                        //Add users to list
                        for( let username in $scope.model) {
                            checkUsername($scope.model[username]);
                        }
                        modelReady = true;
                    }
                }, true);

                $scope.$on('$destroy', function() {
                    modelReady = false;
                });
            }
        }
    }];

